import React, { createContext, useState, useContext, ReactNode } from "react";
import Loader from "../../components/UI/loader/Loader";

// Create a context for loading state
const LoadingContext = createContext<{
  isLoading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}>({
  isLoading: false,
  setLoading: () => {},
});

// Provider component
export const LoadingProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isLoading, setLoading] = useState(false);
  return (
    <LoadingContext.Provider value={{ isLoading, setLoading }}>
      {isLoading && <Loader />}

      {children}
    </LoadingContext.Provider>
  );
};

// Custom hook to use the loading context
export const useLoading = () => useContext(LoadingContext);
